import { render, staticRenderFns } from "./CustomerUpdate.vue?vue&type=template&id=6d03e26a&"
import script from "./CustomerUpdate.vue?vue&type=script&lang=ts&"
export * from "./CustomerUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports